<template>
  <div id="app" class="main-container">
    <TheHeader :error-message="errorMsg" :navigation-links="filteredNavLinks" />

    <transition name="route" mode="out-in">
      <router-view></router-view>
    </transition>

    <TheFooter :navigation-links="filteredNavLinks" />
    <TheConsentModal @setCookie="listenToConsent" :cookie="cookie" />
  </div>
</template>

<script>
import TheFooter from "@/components/layouts/TheFooter.vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import TheConsentModal from "@/components/consent/TheConsentModal.vue";

export default {
  name: "App",
  components: {
    TheFooter,
    TheHeader,
    TheConsentModal,
  },
  data() {
    return {
      navLinks: this.$router.options.routes,
      errorMsg: false,
      cookie: this.$cookies.get("absi_consent"),
      domainName: document.domain,
    };
  },
  computed: {
    filteredNavLinks() {
      // Filtering out the 404 routes
      return this.navLinks.filter((link) => {
        return link.name !== "NotFound" && link.path !== "*";
      });
    },
  },
  updated() {
    this.cookie = this.$cookies.get("absi_consent");
    if (this.$route.params.errormsg) {
      this.errorMsg = true;
    }
  },
  mounted() {
    this.listenToConsent(this.$cookies.get("absi_consent"));
  },
  methods: {
    listenToConsent(consent) {
      if (!consent) {
        this.setWistia(false);
      }
      if (consent === "full_consent") {
        this.setWistia(true);
      } else if (consent === "necessary_consent") {
        this.setWistia(false);
      } else {
        this.$cookies.remove("absi_consent");
      }
    },
    setWistia(bool) {
      window._wq = window._wq || [];
      window._wq.push(function (W) {
        W.consent(bool);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// Route transitions
.route-enter,
.route-leave-to {
  opacity: 0;
  transform: translateY(-200px);
}
.route-enter-to,
.route-leave {
  opacity: 1;
}
.route-enter-active {
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  -ms-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
.route-leave-active {
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  transition: all 0.2s ease-out;
}

.main-content {
  max-width: $app-width;
  width: 100%;
}

.main-container {
  display: flex;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;
}
</style>
